export default __webpack_public_path__ + "static/media/producto-04.cb691566.jpg";